// src/slices/brandManagement/thunk.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getBrandInfo,
  updateBrand,
  uploadBrandLogo,
  deleteBrandLogo,
} from '../../helpers/fakebackend_helper';
import { BrandFormData } from '../../pages/BrandManagement/types';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('brand_management_messages');

/**
 * Lấy thông tin thương hiệu hiện tại
 */
export const fetchBrandInfo = createAsyncThunk(
  'brandManagement/fetchBrandInfo',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getBrandInfo();
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || st('khong_the_tai_thong_tin_thuong_message')
      );
    }
  }
);

/**
 * Cập nhật thông tin thương hiệu
 */
export const updateBrandInfo = createAsyncThunk(
  'brandManagement/updateBrandInfo',
  async (brandData: BrandFormData, { rejectWithValue }) => {
    try {
      const response = await updateBrand(brandData);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || st('khong_the_cap_nhat_thuong_hieu_message')
      );
    }
  }
);

/**
 * Upload logo
 */
export const uploadLogo = createAsyncThunk(
  'brandManagement/uploadLogo',
  async (file: File, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await uploadBrandLogo(formData);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || st('khong_the_upload_logo_message')
      );
    }
  }
);

/**
 * Xóa logo
 */
export const deleteLogo = createAsyncThunk(
  'brandManagement/deleteLogo',
  async (_, { rejectWithValue }) => {
    try {
      await deleteBrandLogo();
      return true;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || st('khong_the_xoa_logo_message')
      );
    }
  }
);